<template>
  <div>
    <NBar title="品牌信息设置" :top="true"/>
    <div class="title">基础设置</div>
    <nut-cell :show-icon="true" title="客服微信" @click-cell="goWeChatSet()" class="diy-cell">
      <div slot="desc">
        <span>未设置</span>
      </div>
    </nut-cell>
    <nut-cell :show-icon="true" title="客服电话" @click-cell="goPhoneSet()" class="diy-cell">
      <div slot="desc">
        <span>未设置</span>
      </div>
    </nut-cell>
    <nut-cell :show-icon="true" title="申诉反馈" @click-cell="goComplainFeedbackSet()" class="diy-cell">
      <div slot="desc">
        <span>未设置</span>
      </div>
    </nut-cell>
    <nut-cell :show-icon="true" title="启动页标题" @click-cell="goStartPageTitleSet()" class="diy-cell"/>
    <nut-cell :show-icon="true" title="设备操作" @click-cell="goDevice()" class="diy-cell"/>
    <nut-cell :show-icon="true" title="充值规则" @click-cell="goRechargeRuleSet()" class="diy-cell"/>
    <nut-cell :show-icon="true" title="卡项设置" @click-cell="goCardSet()" class="diy-cell"/>
    <nut-cell :show-icon="true" title="奖励设置" @click-cell="goSpreadSet()" class="diy-cell"/>
    <nut-cell :show-icon="true" title="代理商帐号设置" @click-cell="goAgentSet()" class="diy-cell"/>
    <div class="title">个性化设置</div>
    <nut-cell :show-icon="true" title="启动页消息通知" @click-cell="goStartPageMsgSet()" class="diy-cell">
    </nut-cell>
    <!--    <nut-cell :show-icon="true" title="皮肤主体" @click-cell="msgWeChat()" class="diy-cell">-->
    <!--    </nut-cell>-->
    <nut-cell :show-icon="true" title="商户品牌名称" @click-cell="goBrandNameSet()" class="diy-cell">
      <div slot="desc">
        <span>未设置</span>
      </div>
    </nut-cell>
    <!--    <nut-cell :show-icon="true" title="游戏币名称" @click-cell="goGameCurrencyNameSet()" class="diy-cell">-->
    <!--      <div slot="desc">-->
    <!--        <span>未设置</span>-->
    <!--      </div>-->
    <!--    </nut-cell>-->
    <nut-cell :show-icon="true" title="banner图设置" @click-cell="goBannerSet()" class="diy-cell">
      <div slot="desc">
        <span>可自定义</span>
      </div>
    </nut-cell>
  </div>
</template>

<script>
export default {
  name: 'BrandInfoSet',
  data() {
    return {}
  },
  methods: {
    //设置客服微信
    goWeChatSet() {
      this.$router.push ('/device/ServiceWeChat')
    },
    //设置客服电话
    goPhoneSet() {
      this.$router.push ('/device/ServicePhone')
    },
    //设置申诉反馈
    goComplainFeedbackSet() {
      this.$router.push ('/device/ComplainFeedback')
    },
    //设置启动页标题
    goStartPageTitleSet() {
      this.$router.push ('/device/StartPageTitle')
    },
    //设备操作
    goDevice() {
      this.$router.push ('/device/DeviceList')
    },
    //设置启动页消息通知
    goStartPageMsgSet() {
      this.$router.push ('/device/StartPageMsg')
    },
    //充值规则设置
    goRechargeRuleSet() {
      this.$router.push ('/device/RechargeRuleSet')
    },
    //卡项设置
    goCardSet() {
      this.$router.push ('/device/Card')
    },
    goSpreadSet() {
      this.$router.push ('/device/SpreadSet')
    },
    //设置商户品牌名称
    goBrandNameSet() {
      this.$router.push ('/device/BrandName')
    },
    //代理商帐号设置
    goAgentSet() {
      this.$router.push ('/device/AgentList')
    },
    //游戏币名称
    goGameCurrencyNameSet() {
      this.$router.push ('/device/GameCurrencyName')
    },
    //banner图设置
    goBannerSet() {
      this.$router.push ('/device/Banner')
    },
  }
}
</script>

<style scoped>
.diy-cell {
  margin: 0px 15px;
  border-radius: 5px;
}

.title {
  margin: 20px 15px 5px 15px;
  color: #848484;
}
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/BrandInfoSet.vue